<template>
  <div class="card card-custom ranking-elos">
    <v-overlay :value="carregando" :absolute="true">
      <v-progress-circular indeterminate size="32" color="#462181" width="2"
        ><v-progress-circular
          indeterminate
          size="24"
          color="#ff7f00"
          width="2"
          rotate="180"
        ></v-progress-circular
      ></v-progress-circular>
    </v-overlay>

    <div class="card-body p-0 d-flex flex-column">
      <div
        class="d-flex align-items-center justify-content-between card-spacer"
      >
        <div class="d-flex align-items-center">
          <span class="card-titulo-icone mr-3"
            ><i class="fas fa-trophy"></i
          ></span>
          <h5 class="m-0 mr-3 card-titulo">Ranking Elos Duradouros</h5>
          <Tooltip
            message="A empresa receberá um prêmio que corresponder ao ranking que representar a sua melhor colocação"
          />
        </div>
        <div class="d-flex align-items-center" style="position: relative">
          <b-button
            variant="success"
            size="sm"
            class="ml-2 ranking-elos__botao-troca"
            @click="toggle"
            ref="BotaoMenu"
          >
            {{ label_botao_menu }}
          </b-button>
          <Menu
            ref="menu_togglable"
            id="overlay_menu"
            :model="timeline_filter_options()"
            style="
              position: absolute;
              transform: translateY(38px);
              z-index: 99;
              right: 0;
            "
            v-if="visible_menu_opcoes"
          />
        </div>
      </div>

      <div class="px-6 pb-6" v-if="carregando">
        <b-skeleton
          v-for="n in 4"
          :key="n"
          animation="wave"
          width="100%"
          height="44px"
          class="mb-2"
        ></b-skeleton>
      </div>

      <template v-else>
        <!-- WEL-5194: pódio (2º, 1º, 3º) — o 1º fica ao centro, mais alto. -->
        <div class="podio px-6">
          <div
            v-for="dado in podio"
            :key="dado.posicao"
            class="podio__lugar"
            :class="[
              nivelClasse(dado.posicao),
              { 'podio__lugar--propria': 'conta_id' in dado }
            ]"
          >
            <i
              :class="['fas', nivelIcone(dado.posicao), 'podio__icone']"
              v-b-tooltip.noninteractive.hover
              :title="'conta_id' in dado ? dado.conta_nome : ''"
            ></i>
            <div class="podio__degrau">
              <span class="podio__posicao">{{ dado.posicao }}º</span>
              <span class="podio__pontos"
                >{{ dado.pontuacao | formatacaoNumero }} pts</span
              >
            </div>
          </div>
        </div>

        <div class="px-6 pb-6 ranking-elos__rodape">
          <!-- No pódio o destaque no degrau é sutil, então reforça com uma
          mensagem de parabéns. Fora do pódio, mostra a posição da conta. -->
          <div v-if="estaNoTop3" class="ranking-elos__parabens">
            <span class="ranking-elos__confetes ranking-elos__confetes--esq"
              >◆ • ◆</span
            >
            <i class="fas fa-trophy"></i>
            <span
              >Parabéns! Você está em
              <strong>{{ contaAtual.posicao }}º</strong> no pódio</span
            >
            <span class="ranking-elos__confetes ranking-elos__confetes--dir"
              >◆ • ◆</span
            >
          </div>
          <div v-else class="ranking-elos__minha-posicao">
            <i
              class="fas fa-ranking-star ranking-elos__minha-posicao-icone"
            ></i>
            <template v-if="contaAtual.posicao">
              <span class="ranking-elos__minha-posicao-texto"
                >Sua posição: <strong>{{ contaAtual.posicao }}º</strong></span
              >
              <span class="ranking-elos__minha-posicao-separador">•</span>
              <span class="ranking-elos__minha-posicao-pontos"
                >{{ contaAtual.pontuacao | formatacaoNumero }} pts</span
              >
            </template>
            <span v-else class="ranking-elos__minha-posicao-texto"
              >Pontuação insuficiente para o ranking</span
            >
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Tooltip from "./Tooltip.vue";
import Menu from "primevue/menu";

const NIVEL_INFO = {
  1: { classe: "ranking-item--ouro", icone: "fa-trophy" },
  2: { classe: "ranking-item--prata", icone: "fa-medal" },
  3: { classe: "ranking-item--bronze", icone: "fa-award" }
};

export default {
  name: "RankingElosDuradouros",
  components: {
    Tooltip,
    Menu
  },
  props: {
    carregando: {
      type: Boolean,
      required: true
    },
    dados: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selecionado: null,
      visible_menu_opcoes: false
    };
  },
  watch: {
    dados: {
      handler() {
        this.selecionarCategoria(this.label_botao_menu);
      },
      deep: true
    }
  },
  filters: {
    formatacaoNumero(value) {
      let valor = value;
      if (typeof value !== "number") {
        valor = parseInt(value);
      }
      return valor.toLocaleString("pt-BR");
    }
  },
  computed: {
    contaAtual() {
      if (!this.selecionado?.conta_atual) {
        return { conta_nome: "X", posicao: "X", pontuacao: "0" };
      }
      return this.selecionado.conta_atual;
    },
    // WEL-5193: só o pódio (top 3) — o restante de todas_contas não é
    // exibido no card compacto da Home.
    top3() {
      return this.selecionado?.todas_contas?.slice(0, 3) || [];
    },
    // WEL-5194: ordem VISUAL do pódio (2º, 1º, 3º) — o 1º ao centro.
    // A ordem de dados continua 1,2,3; só a exibição muda.
    podio() {
      const porPosicao = (p) => this.top3.find((d) => d.posicao === p);
      return [porPosicao(2), porPosicao(1), porPosicao(3)].filter(Boolean);
    },
    estaNoTop3() {
      return Boolean(this.contaAtual.posicao) && this.contaAtual.posicao <= 3;
    },
    label_botao_menu() {
      if (!Object.keys(this.dados).length) {
        return "Atende";
      }
      if (!this.selecionado) {
        return (
          Object.keys(this.dados)[0].charAt(0).toUpperCase() +
          Object.keys(this.dados)[0].slice(1)
        );
      }
      return this.selecionado.label;
    }
  },
  methods: {
    nivelClasse(posicao) {
      return NIVEL_INFO[posicao]?.classe || "";
    },
    nivelIcone(posicao) {
      return NIVEL_INFO[posicao]?.icone || "fa-award";
    },
    selecionarCategoria(categoria) {
      this.selecionado = this.dados[categoria.toLowerCase()];
      if (!this.selecionado) return;
      this.selecionado.label =
        categoria.charAt(0).toUpperCase() + categoria.slice(1);
      this.closeMenu();
    },
    closeMenu() {
      this.visible_menu_opcoes = false;
    },
    toggle() {
      this.visible_menu_opcoes = !this.visible_menu_opcoes;
    },
    timeline_filter_options() {
      return Object.keys(this.dados).map((key) => {
        return {
          label: key.charAt(0).toUpperCase() + key.slice(1),
          command: () => {
            this.selecionarCategoria(key);
          }
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.ranking-elos {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 250px;
  overflow: hidden;
  border: 1px solid rgba(151, 103, 205, 0.32);
  border-radius: 10px;
  background: #472282;
  box-shadow: 0 10px 28px rgba(35, 8, 55, 0.18);

  &::before,
  &::after {
    content: "";
    position: absolute;
    border-radius: 50%;
    pointer-events: none;
  }

  &::before {
    width: 170px;
    height: 170px;
    top: -105px;
    right: -55px;
    border: 1px solid rgba(255, 255, 255, 0.08);
  }

  &::after {
    width: 110px;
    height: 110px;
    right: 18%;
    bottom: -82px;
    background: rgba(255, 127, 0, 0.08);
  }

  .card-body {
    position: relative;
    z-index: 1;
    min-height: 100%;
  }

  .card-spacer {
    padding: 1.15rem 1.35rem 0.7rem !important;
  }

  .card-titulo,
  .card-titulo-icone,
  .card-titulo-icone i {
    color: #fff !important;
  }

  .card-titulo-icone {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 9px;
    background: rgba(255, 255, 255, 0.1);
  }

  .ranking-elos__botao-troca {
    color: #fff !important;
    background: rgba(92, 37, 132, 0.58) !important;
    border: 1px solid rgba(235, 218, 251, 0.72) !important;
    border-radius: 8px;
    box-shadow: none !important;
  }
}

// WEL-5194: pódio — degraus alinhados pela base, 1º ao centro e mais alto.
.podio {
  position: relative;
  display: flex;
  align-items: flex-end;
  gap: 0.55rem;
  min-height: 128px;
  padding: 0.35rem 1rem 0 !important;

  &::after {
    content: "";
    position: absolute;
    right: 8%;
    bottom: 0;
    left: 8%;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.24),
      transparent
    );
  }
}

.podio__lugar {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.podio__icone {
  font-size: 1.75rem !important;
  margin-bottom: 0.45rem;
  filter: drop-shadow(0 4px 7px rgba(0, 0, 0, 0.32));
  transform: translateY(0);
  transition: transform 0.2s ease;
}

.podio__lugar:hover .podio__icone {
  transform: translateY(-3px);
}

.podio__degrau {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
  height: 70px;
  padding: 0.45rem 0.4rem;
  border-radius: 8px 8px 3px 3px;
  border: 1px solid transparent;
  background: rgba(255, 255, 255, 0.07);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.podio__posicao {
  font-weight: 800;
  font-size: 1.3rem;
  line-height: 1;
  color: #fff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
}

.podio__pontos {
  font-size: 0.78rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.72);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

// O 1º lugar (centro) tem degrau e ícone maiores.
.ranking-item--ouro {
  .podio__icone {
    font-size: 2.25rem !important;
    color: #f5a000 !important;
    filter: drop-shadow(0 0 8px rgba(245, 160, 0, 0.42));
  }

  .podio__degrau {
    height: 88px;
    background: linear-gradient(
      180deg,
      rgba(94, 44, 75, 0.72),
      rgba(42, 18, 48, 0.9)
    );
    border-color: #f5a000;
    box-shadow: inset 0 0 24px rgba(245, 160, 0, 0.08),
      0 0 13px rgba(245, 160, 0, 0.2);
  }

  .podio__posicao {
    font-size: 1.5rem;
    line-height: 1;
    color: #ffb321;
    text-shadow: 0 0 12px rgba(245, 160, 0, 0.35);
  }

  .podio__pontos {
    color: #f2a918;
  }
}

.ranking-item--prata {
  .podio__icone {
    color: #d7dce7 !important;
    filter: drop-shadow(0 0 7px rgba(215, 220, 231, 0.3));
  }

  .podio__degrau {
    background: linear-gradient(
      180deg,
      rgba(75, 75, 111, 0.7),
      rgba(37, 28, 58, 0.9)
    );
    border-color: #aeb8ca;
  }

  .podio__posicao {
    color: #d7dce7;
  }

  .podio__pontos {
    color: #c5cad6;
  }
}

.ranking-item--bronze {
  .podio__icone {
    color: #ff8739 !important;
    filter: drop-shadow(0 0 7px rgba(255, 126, 47, 0.34));
  }

  .podio__degrau {
    background: linear-gradient(
      180deg,
      rgba(104, 49, 46, 0.68),
      rgba(51, 22, 37, 0.9)
    );
    border-color: #d98a52;
  }

  .podio__posicao {
    color: #ff9148;
  }

  .podio__pontos {
    color: #e88a51;
  }
}

// Conta logada no pódio: contorno na cor do nível, sem mudar a altura.
.podio__lugar--propria .podio__degrau {
  box-shadow: inset 0 0 0 2px currentColor;
}

.ranking-item--ouro.podio__lugar--propria .podio__degrau {
  color: #f5a000;
}

.ranking-item--prata.podio__lugar--propria .podio__degrau {
  color: #9ca3af;
}

.ranking-item--bronze.podio__lugar--propria .podio__degrau {
  color: #c66a2b;
}

.ranking-elos__minha-posicao {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 0.85rem;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.16);
}

.ranking-elos__minha-posicao-icone {
  color: #472282 !important;
}

.ranking-elos__minha-posicao-texto {
  color: #fff;
  font-size: 0.88rem;
  font-weight: 600;
}

.ranking-elos__minha-posicao-separador {
  color: #a99fd0;
}

.ranking-elos__minha-posicao-pontos {
  color: #fff;
  font-weight: 700;
  font-size: 0.88rem;
}

.ranking-elos__parabens {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 0.85rem;
  border-radius: 10px;
  background: linear-gradient(90deg, #075727, #087735, #075727);
  border: 1px solid rgba(55, 206, 112, 0.48);
  color: #fff;
  font-size: 0.88rem;
  font-weight: 600;
  overflow: hidden;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12),
    0 5px 14px rgba(0, 0, 0, 0.2);

  i {
    color: #fff !important;
    font-size: 1.15rem !important;
  }
}

.ranking-elos__rodape {
  padding: 0.65rem 0.85rem 0.85rem !important;
}

.ranking-elos__confetes {
  position: absolute;
  top: 50%;
  color: #ff8a00;
  font-size: 0.64rem;
  letter-spacing: 0.3rem;
  white-space: nowrap;
  transform: translateY(-50%) rotate(-12deg);
  opacity: 0.95;
}

.ranking-elos__confetes--esq {
  left: 0.55rem;
}

.ranking-elos__confetes--dir {
  right: 0.3rem;
  transform: translateY(-50%) rotate(12deg);
}

@media (max-width: 1199px) {
  .ranking-elos__confetes {
    display: none;
  }

  .podio__pontos {
    font-size: 0.7rem;
  }
}
</style>
